import { fabric } from "fabric";
import { createRafFpsScheduler } from "@/utils/raf";
import { useEditorStore } from "../../../helper/store/editor";
import { imageLoader } from "../../../helper/ImageLoader";

/**
 * 创建光标追踪器
 * 负责监听鼠标移动并更新 Store 中的鼠标位置
 */
export const createCursorTracker = (canvas: fabric.Canvas) => {
  const editorStore = useEditorStore();

  let lastMouseX: number | null = null;
  let lastMouseY: number | null = null;

  // 使用 RAF 节流更新鼠标位置，避免高频触发导致性能问题
  const scheduler = createRafFpsScheduler<MouseEvent>((nativeEvent) => {
    if (!nativeEvent || !canvas.getElement()) return;

    // 加载 900+ 图片时 updateMousePosition 会触发大量 Vue 响应式更新，跳过以减轻主线程压力
    if (!imageLoader.isIdle()) return;

    const pointer = canvas.getPointer(nativeEvent);
    const threshold = 0.5;

    // 仅当移动距离超过阈值时才更新
    if (
      lastMouseX === null ||
      lastMouseY === null ||
      Math.abs(pointer.x - lastMouseX) > threshold ||
      Math.abs(pointer.y - lastMouseY) > threshold
    ) {
      lastMouseX = pointer.x;
      lastMouseY = pointer.y;
      editorStore.updateMousePosition(pointer);
    }
  }, 60);

  return {
    move: (e: fabric.IEvent) => {
      // 画笔绘制态跳过坐标追踪：绘制时 mouse:move 极高频，而坐标指示器在绘制中无意义。
      // 此处提前 return 可省去 getPointer（强制 reflow）、Vue 响应式更新及 rAF/setTimeout 调度，
      // 避免与 PencilBrush 绘制争抢主线程（实测为绘制卡顿的主要来源之一）。
      if (canvas.isDrawingMode) return;
      if (e.e) scheduler.schedule(e.e as MouseEvent);
    },
    out: () => scheduler.cancel()
  };
};
